<template>
  <div class="my-4 mx-1 site-info">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>基础配置</el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="text-primary">站点信息</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>

    <el-card class="my-3 mx-1" element-loading-text="拼命加载中">
      <div slot="header">
        <span class="font-weight-bold text-primary">站点信息设置</span>
      </div>
      <div
        style="height: 470px;overflow-y: auto;padding-right: 60px"
        v-loading="loading"
      >
        <el-form :model="siteInfo" class="font-weight-bold" label-width="120px">
          <el-form-item label="站点标题">
            <el-input v-model="siteInfo.siteTitle"></el-input>
          </el-form-item>
          <el-form-item label="站点副标题">
            <el-input v-model="siteInfo.siteSubTitle"></el-input>
          </el-form-item>
          <el-form-item label="站点LOGO">
            <el-input
              v-model="siteInfo.siteLogo"
              autocomplete="off"
              placeholder="站点LOGO URL"
            >
            </el-input>
            <div class="d-flex">
              <img-upload
                @onUpload="uploadImg(1)"
                ref="siteLogoUpload"
              ></img-upload>
              <small class="text-muted ml-3">推荐图片尺寸160*40像素</small>
            </div>
            <div class="mt-2" title="点击查看大图">
              <el-image
                class="img-thumbnail"
                :src="siteInfo.siteLogo"
                :preview-src-list="[siteInfo.siteLogo]"
                alt="站点LOGO"
              />
            </div>
          </el-form-item>
          <el-form-item label="导航栏背景图">
            <el-input
              v-model="siteInfo.topBackground"
              autocomplete="off"
              placeholder="导航栏背景图 URL"
            >
            </el-input>
            <div class="d-flex">
              <img-upload
                @onUpload="uploadImg(2)"
                ref="topBackgroundUpload"
              ></img-upload>
              <small class="text-muted ml-3">推荐图片尺寸1500*400像素</small>
            </div>
            <div class="mt-2" title="点击查看大图">
              <el-image
                class="img-thumbnail"
                width="800"
                :src="siteInfo.topBackground"
                :preview-src-list="[siteInfo.topBackground]"
                alt="导航栏背景图"
              />
            </div>
          </el-form-item>
          <el-form-item label="页面底部背景图">
            <el-input
              v-model="siteInfo.bottomBackground"
              autocomplete="off"
              placeholder="站点LOGO URL"
            >
            </el-input>
            <div class="d-flex">
              <img-upload
                @onUpload="uploadImg(3)"
                ref="bottomBackgroundUpload"
              ></img-upload>
              <small class="text-muted ml-3">推荐图片尺寸1500*500像素</small>
            </div>
            <div class="mt-2" title="点击查看大图">
              <el-image
                class="img-thumbnail"
                width="800"
                :src="siteInfo.bottomBackground"
                :preview-src-list="[siteInfo.bottomBackground]"
                alt="页面底部背景图"
              />
            </div>
          </el-form-item>
          <el-form-item label="站点关键字">
            <el-input v-model="siteInfo.siteKeyword"></el-input>
          </el-form-item>
          <el-form-item label="站点备案">
            <el-input v-model="siteInfo.siteRecord"></el-input>
          </el-form-item>
          <el-form-item label="尾部信息">
            <el-input v-model="siteInfo.bottomInfo"></el-input>
          </el-form-item>
          <el-form-item label="尾部提示">
            <el-input v-model="siteInfo.bottomTips"></el-input>
          </el-form-item>
          <el-form-item label="尾部公司信息">
            <el-input v-model="siteInfo.bottomCompany"></el-input>
          </el-form-item>
          <el-form-item label="站点描述">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              v-model="siteInfo.siteDesc"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="
              adminPermissions.includes('/siteInformation/admin/updateSiteInfo')
            "
          >
            <el-button type="primary" @click="submitSiteForm(siteInfo)"
              >立即提交
            </el-button>
            <el-button @click="getSiteInfo()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
import ImgUpload from "../../components/common/ImgUpload";

export default {
  name: "SiteInfo",
  data() {
    return {
      siteInfo: {
        siteLogo: "",
        topBackground: "",
        bottomBackground: ""
      },
      adminPermissions: this.$store.state.adminPermissions,
      loading: true
    };
  },
  components: {
    ImgUpload
  },
  mounted() {
    this.getSiteInfo();
  },
  methods: {
    getSiteInfo() {
      this.axios.get("/siteInformation/admin/getSiteInfo").then(resp => {
        if (resp && resp.data.code === 10000 && resp.data.success) {
          this.siteInfo = resp.data.data;
          this.loading = false;
        }
      });
    },
    uploadImg(value) {
      if (value === 1) {
        this.siteInfo.siteLogo = this.$refs.siteLogoUpload.url;
      }
      if (value === 2) {
        this.siteInfo.topBackground = this.$refs.topBackgroundUpload.url;
      }
      if (value === 3) {
        this.siteInfo.bottomBackground = this.$refs.bottomBackgroundUpload.url;
      }
    },
    submitSiteForm(siteInfo) {
      this.axios
        .post("/siteInformation/admin/updateSiteInfo", {
          siteId: siteInfo.siteId,
          siteTitle: siteInfo.siteTitle,
          siteSubTitle: siteInfo.siteSubTitle,
          siteLogo: siteInfo.siteLogo,
          siteKeyword: siteInfo.siteKeyword,
          siteDesc: siteInfo.siteDesc,
          siteRecord: siteInfo.siteRecord,
          bottomInfo: siteInfo.bottomInfo,
          bottomTips: siteInfo.bottomTips,
          bottomCompany: siteInfo.bottomCompany,
          topBackground: siteInfo.topBackground,
          bottomBackground: siteInfo.bottomBackground
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$notify({
              title: "成功",
              message: "修改成功",
              type: "success"
            });
            this.getSiteInfo();
          } else {
            this.$notify.error({
              title: "错误",
              message: "操作失败！"
            });
          }
        });
    }
  }
};
</script>

<style lang="scss"></style>
